// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3owre","bigColWidth":"Table_bigColWidth__2ZoCq","biggerColWidth":"Table_biggerColWidth__tNSG-","row":"Table_row__1WRA_","col":"Table_col__2XT6y"};